import type { LegalAgreement } from "@/Modules/Models/Domain/LegalAgreement";

import { acceptAgreementTherapist } from "@/Services/TherapyApi/LegalAgreements";

import useCustomerStore from "../Store";

import { hasValue } from "@/Utils/Objects";

async function acceptLegalAgreementsAH(
  customerUuid: string,
  legalAgreementUuid: string
): Promise<LegalAgreement | undefined> {
  const customerStore = useCustomerStore();

  const la = await acceptAgreementTherapist(legalAgreementUuid);

  if (!hasValue(la)) return undefined;

  if (
    hasValue(customerStore.customers[customerUuid]) &&
    hasValue(customerStore.customers[customerUuid].legalAgreements)
  ) {
    customerStore.customers[customerUuid].legalAgreements = customerStore.customers[
      customerUuid
    ].legalAgreements.map((l) => {
      if (l.uuid !== la.uuid) return l;

      return la;
    });
  }

  return la;
}

export default acceptLegalAgreementsAH;
